export default "__VITE_ASSET__DSEH1GJU__"